import * as bodyScrollLock from '@ynap-ofs/body-scroll-ynap'

const CLASS_NOSCROLL = 'blockScroll'

/**
 * Use these methods to block/unblock page.
 * @author MiceliF
 */
class Overlay {
	constructor() {
		this.blockCounter = 0
	}

	block(targetElement, allowTouchMove = true) {
		this.blockCounter += 1
		yTos.notify('CAR::freezeHeaderPosition')
		document.documentElement.classList.add(CLASS_NOSCROLL)

		if (!allowTouchMove) {
			bodyScrollLock.disableBodyScroll(targetElement)
		} else {
			bodyScrollLock.disableBodyScroll(targetElement, {
				allowTouchMove: () => true,
			})
		}

		yTos.notify('CAR::Overlay::block')
	}

	unBlock() {
		this.blockCounter -= 1
		if (this.blockCounter > 0) {
			return
		}
		this.unBlockAll()
	}

	/* This should be called if the element that blocked the scroll might no longer be in the DOM when unblocking it.
	Note that it also unblocks the scroll for any other element that might have it blocked. */
	unBlockAll() {
		document.documentElement.classList.remove(CLASS_NOSCROLL)
		bodyScrollLock.clearAllBodyScrollLocks()
		yTos.notify('CAR::Overlay::unBlock')
		yTos.notify('CAR::resumeHeaderBehaviour')
	}
}

export default Overlay
